<template>
	<div class="column flexible card card-primary">
		<h2 class="rigid placeholder"></h2>
		<section class="flexible column separated">
			<div class="rigid gray-7 card-content placeholder">
			</div>
			<small class="rigid placeholder"></small>
		</section>
		<footer class="row rigid separated">
			<button class="flexible" disabled>
				<div class="placeholder"></div>
			</button>
			<button class="flexible" disabled>
				<div class="placeholder"></div>
			</button>
		</footer>
	</div>
</template>

<script>
export default {
	name: 'CardPlaceholder'
};
</script>

<style scoped>
	h2.placeholder {
		background-color: #CCC;
		height: 1em;
		width: 25%
	}
	.dark h2.placeholder {
		background-color: #666;
	}
	.card-content {
		height: 1em;
		width: 75%
	}
	.dark .card-content.placeholder {
		background-color: #243044;
	}
	small.placeholder {
		background-color: #f2f2f2;
		height: 1em;
		width: 50%
	}
	.dark small.placeholder {
		background: #333;
	}
	button > .placeholder {
		height: 1.375rem;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/CardPlaceholder.vue